import { render, staticRenderFns } from "./AdminValidation.vue?vue&type=template&id=04fb65d0&"
import script from "./AdminValidation.vue?vue&type=script&lang=js&"
export * from "./AdminValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports